import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";

import CardSection from "./CardSection";
import { UnAuthServices } from "src/services";

export default function CheckoutForm() {
  const stripe: any = useStripe();
  const elements = useElements();

  const handleSubmit = async (event: any) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    const card = elements.getElement(CardElement);
    console.log("card: ", card);

    const result = await stripe.createPaymentMethod({
      type: "card",
      card,
    });

    console.log("result->", result);

    stripePaymentMethodHandler(result);
  };

  const stripePaymentMethodHandler = async (result: any) => {
    if (result.error) {
      // Show error in payment form
    } else {
      // Otherwise send paymentMethod.id to your server (see Step 4)
      const res = await UnAuthServices.user_test_stripe({
        param_datas: {
          payment_method_id: result.paymentMethod.id,
        },
      });
      const paymentResponse = res.data;

      // Handle server response (see Step 4)
      handleServerResponse(paymentResponse);
    }
  };

  const handleServerResponse = async (response: any) => {
    if (response.error) {
      // Show error from server on payment form
    } else if (response.requires_action) {
      // Use Stripe.js to handle the required card action
      const { error: errorAction, paymentIntent } =
        await stripe.handleCardAction(response.payment_intent_client_secret);

      if (errorAction) {
        // Show error from Stripe.js in payment form
      } else {
        // The card action has been handled
        // The PaymentIntent can be confirmed again on the server
        // const serverResponse = await fetch("/pay", {
        //   method: "POST",
        //   headers: { "Content-Type": "application/json" },
        //   body: JSON.stringify({ payment_intent_id: paymentIntent.id }),
        // });
        const serverResponse = await UnAuthServices.user_test_stripe({
          param_datas: {
            payment_intent_id: paymentIntent.id,
          },
        });
        handleServerResponse(serverResponse.data);
      }
    } else {
      // Show success message
      console.log("payment success message");
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div style={{ width: 300 }}>
        <CardSection />
        <button type="submit" disabled={!stripe}>
          Submit Payment
        </button>
      </div>
    </form>
  );
}
